import { z } from 'zod';

import { RehireRecommendation, ReplacementValue } from '@/common/graphql';

export const RehiringEligibilityFilter = z.object({
  rehireRecommendations: z.array(z.nativeEnum(RehireRecommendation)).default([]),
  replacementValues: z.array(z.nativeEnum(ReplacementValue)).default([]),
});
export type RehiringEligibilityFilterType = z.infer<typeof RehiringEligibilityFilter>;
